import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { Typography, ZendeskLink } from 'app/shared/components/atoms';
import { MappingsProps } from 'app/fan/components/templates/EventPage/components/EventCharacteristicsList/utils';
import { ReactComponent as MartiniGlass } from 'icons/alcohol.svg';
import { ReactComponent as ForkAndKnife } from 'icons/food.svg';
import { ReactComponent as Prohibited } from 'icons/prohibited.svg';

export function useFoodAndBeverageMappings({ formatMessage }: MappingsProps) {
  const { colors } = useCurrentTheme();
  const intlPrefix = 'event.eventCharacteristicsList.foodAndBeverage';
  const beverageId = 'beverage_rules';
  const foodId = 'food_rules';

  return {
    alcoholNotPermittedOrSold: {
      id: beverageId,
      title: formatMessage({ id: `${intlPrefix}.alcoholNotPermittedOrSold` }),
      icon: Prohibited,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({
            id: `${intlPrefix}.alcoholNotPermittedOrSold.details`,
          })}
        </Typography>
      ),
    },
    alcoholForSaleAndByobNoRedWine: {
      id: beverageId,
      title: formatMessage({
        id: `${intlPrefix}.alcoholForSaleAndByobNoRedWine`,
      }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({
            id: `${intlPrefix}.alcoholForSaleAndByobNoRedWine.details`,
          })}
        </Typography>
      ),
    },
    alcoholForSaleNoRedWineForSale: {
      id: beverageId,
      title: formatMessage({
        id: `${intlPrefix}.alcoholForSaleNoRedWineForSale`,
      }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({
            id: `${intlPrefix}.alcoholForSaleNoRedWineForSale.details`,
          })}
        </Typography>
      ),
    },
    alcoholForSaleAndByob: {
      id: beverageId,
      title: formatMessage({ id: `${intlPrefix}.alcoholForSaleAndByob` }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.alcoholForSaleAndByob.details` })}
        </Typography>
      ),
    },
    alcoholForSaleNoByob: {
      id: beverageId,
      title: formatMessage({ id: `${intlPrefix}.alcoholForSaleNoByob` }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.alcoholForSaleNoByob.details` })}
        </Typography>
      ),
    },
    byobNoRedWine: {
      id: beverageId,
      title: formatMessage({ id: `${intlPrefix}.byobNoRedWine` }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.byobNoRedWine.details` })}
        </Typography>
      ),
    },
    byob: {
      id: beverageId,
      title: formatMessage({ id: `${intlPrefix}.byob` }),
      icon: MartiniGlass,
      details: (
        <Typography color={colors.primary.white.base}>
          {formatMessage({ id: `${intlPrefix}.byob.details` })}
        </Typography>
      ),
    },
    foodForSaleNoOutsideFood: {
      id: foodId,
      title: formatMessage({ id: `${intlPrefix}.foodForSaleNoOutsideFood` }),
      icon: ForkAndKnife,
      details: (
        <>
          <Typography display="inline" color={colors.primary.white.base}>
            {formatMessage(
              {
                id: `${intlPrefix}.foodForSaleNoOutsideFood.details`,
              },
              {
                a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
              }
            )}
          </Typography>
        </>
      ),
    },
    noOutsideFood: {
      id: foodId,
      title: formatMessage({ id: `${intlPrefix}.noOutsideFood` }),
      icon: Prohibited,
      details: (
        <>
          <Typography display="inline" color={colors.primary.white.base}>
            {formatMessage(
              {
                id: `${intlPrefix}.noOutsideFood.details`,
              },
              {
                a: (chunks) => <ZendeskLink>{chunks}</ZendeskLink>,
              }
            )}
          </Typography>
        </>
      ),
    },
    foodAvailableForSale: {
      id: foodId,
      title: formatMessage({ id: `${intlPrefix}.foodAvailableForSale` }),
      icon: ForkAndKnife,
      details: (
        <Typography display="inline" color={colors.primary.white.base}>
          {formatMessage({
            id: `${intlPrefix}.foodAvailableForSale.details`,
          })}
        </Typography>
      ),
    },
    snacksAllowed: {
      id: foodId,
      title: formatMessage({ id: `${intlPrefix}.snacksAllowed` }),
      icon: ForkAndKnife,
      details: (
        <Typography display="inline" color={colors.primary.white.base}>
          {formatMessage({
            id: `${intlPrefix}.snacksAllowed.details`,
          })}
        </Typography>
      ),
    },
  };
}
